import { render, staticRenderFns } from "./dailyServiceCharge.vue?vue&type=template&id=affb2bfe&"
import script from "./dailyServiceCharge.vue?vue&type=script&lang=js&"
export * from "./dailyServiceCharge.vue?vue&type=script&lang=js&"
import style0 from "./dailyServiceCharge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports